var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-materials-slider" },
    [
      _c(
        "vue-slider",
        _vm._b(
          {
            scopedSlots: _vm._u([
              {
                key: "tooltip",
                fn: function(ref) {
                  var value = ref.value
                  return [
                    _c("div", { staticClass: "diy-tooltip" }, [
                      _vm.updatedValue
                        ? _c("span", [
                            _vm.tooltipValueText
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.tooltipValueText))
                                ])
                              : _c("span", [_vm._v(_vm._s(_vm.tooltipValue))])
                          ])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ]),
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          },
          "vue-slider",
          _vm.options,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-335686c6", { render: render, staticRenderFns: staticRenderFns })
  }
}